<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.01728 12.4925C7.72783 12.2204 7.72783 11.7792 8.01728 11.5071L14.9349 5.00389C15.2244 4.73178 15.6937 4.73178 15.9831 5.00389C16.2726 5.27599 16.2726 5.71717 15.9831 5.98927L9.58955 11.9998L15.9831 18.0103C16.2726 18.2824 16.2726 18.7236 15.9831 18.9957C15.6937 19.2678 15.2244 19.2678 14.9349 18.9957L8.01728 12.4925Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronLeft',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
